import React, { useContext, useEffect, useMemo, useState } from 'react'
import { dateCol, intCol, strCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import { CriteriaRow } from 'core/screen-util'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import {
  deleteCtInspctionInterval,
  updateCtInspctionInterval,
  getCtInspctionInterval,
  getCtModal,
  getCtInspctionType,
} from 'api/pgads.js'

import CommonScreen from 'admin/component/CommonScreen'
import { Button, Input, DatePicker, Select, InputNumber } from 'antd'

import {
  getEnvConfig,
  getPermitActions,
  getUnitNameMap,
  getUtilityNameMap,
} from '../core/selectors'
import { ErrorContext } from 'context'
import R from 'ramda'
const headers = [
  dateCol({
    ident: 'effectiveDate',
    display: 'Effective Date',
    isKey: true,
    width: 100,
    sortOrder: 'desc',
  }),
  strCol({
    ident: 'modelCode',
    display: 'Model Code',
    isKey: true,
    width: 200,
    sortOrder: 'asc',
  }),
  strCol({
    ident: 'inspectionTypeCode',
    display: 'Inspection Type Code',
    isKey: true,
    width: 300,
    sortOrder: 'asc',
  }),
  intCol({ ident: 'serviceHours', display: 'Service Hours' }),
  intCol({ ident: 'starts', display: 'Starts' }),
  strCol({
    ident: 'comments',
    display: 'Comments',
    width: 500,
    sortOrder: 'asc',
    ellipsis: true,
  }),
]

const title = 'CT Inspection Interval'

const CtInspInterval = ({ envConfig, actionPermits, targetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [modelMap, setModelMap] = useState({})
  const [inspCodeMap, setInspCodeMap] = useState({})
  const { setError } = useContext(ErrorContext)
  useEffect(
    _ => {
      getCtModal(targetInfo).fork(setError, data => {
        const md = R.compose(
          R.fromPairs,
          R.map(u => [u.modelCode, u.model])
        )(data)
        setModelMap(md)
      })
      getCtInspctionType(targetInfo).fork(setError, data => {
        const md = R.compose(
          R.fromPairs,
          R.map(u => [u.inspectionId, u.inspectionType])
        )(data)
        setInspCodeMap(md)
      })
    },
    [targetInfo, setError]
  )

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <CriteriaRow>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '100px 200px 100px 200px 150px 350px',
            gap: '10px',
          }}
        >
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Effective Date :
          </div>
          <DatePicker
            style={{ minWidth: '120px' }}
            onChange={date =>
              setInsertData({
                ...insertData,
                effectiveDate: date.format('YYYY-MM-DD'),
                effectiveDate2: date,
                // transDate: date,
              })
            }
            value={insertData.effectiveDate2}
            placeholder="Effective Date"
            format="MM/DD/YYYY"
            allowClear={false}
          />

          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Modal Code :
          </div>
          <Select
            style={{ width: '100%' }}
            value={insertData.modelCode}
            onChange={value => {
              setInsertData({
                ...insertData,
                modelCode: value,
              })
            }}
          >
            {Object.keys(modelMap).map(k => (
              <Select.Option key={k} value={k}>
                {k}
              </Select.Option>
            ))}
          </Select>
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Inspection Code :
          </div>
          <Select
            style={{ width: '100%' }}
            value={insertData.inspectionTypeCode}
            onChange={value => {
              setInsertData({
                ...insertData,
                inspectionTypeCode: value,
              })
            }}
          >
            {Object.keys(inspCodeMap).map(k => (
              <Select.Option key={k} value={k}>
                {k}-{inspCodeMap[k]}
              </Select.Option>
            ))}
          </Select>

          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Service Hours :
          </div>
          <InputNumber
            style={{ width: '100%' }}
            value={insertData.serviceHours}
            onChange={serviceHours => {
              setInsertData({
                ...insertData,
                serviceHours,
              })
            }}
          />
          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Starts :
          </div>
          <InputNumber
            style={{ width: '100%' }}
            value={insertData.starts}
            onChange={starts => {
              setInsertData({
                ...insertData,
                starts,
              })
            }}
          />

          <div
            style={{
              display: 'grid',
              justifyContent: 'end',
              alignContent: 'center',
            }}
          >
            Comment :
          </div>

          <Input
            style={{ width: '100%' }}
            value={insertData.comments}
            onChange={e => {
              setInsertData({
                ...insertData,
                comments: e.target.value,
              })
            }}
          />

          <div />
          <div
            style={{
              display: 'grid',
              // justifyContent: 'space-around',
              gridTemplateColumns: '100px 150px 150px auto',
              gap: '10px',
              width: '90%',
            }}
          >
            <Button type="primary" onClick={() => onAdd(true)}>
              Add
            </Button>
            <Button type="primary" onClick={() => onAdd(false)}>
              Add & Hide
            </Button>
            <Button type="danger" onClick={onCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </CriteriaRow>
    )
  }

  const hasWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.CT_INSPECTION_ADMIN],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )

  const headerWithFormatter = headers.map(h =>
    h.ident === 'inspectionTypeCode'
      ? {
          ...h,
          // ...toSelectionColProps(utilityNameMap),
          dataFormatter: ({ value }) =>
            inspCodeMap[value] ? `${value}-${inspCodeMap[value]}` : value,
          sortIndexGetter: ({ rowData }) =>
            inspCodeMap[rowData.inspectionTypeCode] ||
            rowData.inspectionTypeCode,
        }
      : h
  )

  return (
    <CommonScreen
      // heightOffset={250}
      widthOffset={50}
      insertCompHeight={50}
      // totalWidth={700}
      isAdminScreen={false}
      withoutModify={!hasWritePermission}
      allowInsert={hasWritePermission}
      title={title}
      header={headerWithFormatter}
      saveTask={updateCtInspctionInterval}
      retrieveTask={getCtInspctionInterval}
      deleteTask={deleteCtInspctionInterval}
      autoRetrieve
      sortOptions={headers}
      insertComp={insertEvent && hasWritePermission && insertComp}
      onInsertEvent={b => setInsertEvent(hasWritePermission && b)}
      headerRowHeight={30}
    />
  )
}

const mapStateToProps = state => ({
  targetInfo: getApiTargetInfo(state),
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  unitNameMap: getUnitNameMap(state),
  utilityNameMap: getUtilityNameMap(state),
})

export default connect(mapStateToProps)(CtInspInterval)
